import { useSelector } from 'react-redux';

import { DisclosureCard } from '@app/components/DisclosureCard';
import { selectAddOns, selectPlanCharacteristics } from '@app/redux';

import LoadingCard from '../LoadingCard';
import { shouldRenderAddonDisclosure } from '../../utils';
import { ProductInstanceTypes } from '../../../../../../platform/src/server/dataSources/PSM/types';

const ReviewPlans = () => {
  const { currentAddOns, loading: addonsLoading } = useSelector(selectAddOns);
  const { characteristics, loading: planLoading } = useSelector(selectPlanCharacteristics);

  if (addonsLoading || planLoading) {
    return <LoadingCard />;
  }

  return (
    <>
      <DisclosureCard name={characteristics.name} kind={ProductInstanceTypes.Internet} />
      {currentAddOns?.map(({ name, kind }) =>
        shouldRenderAddonDisclosure(kind) ? <DisclosureCard key={name} name={name} kind={kind} /> : null
      )}
    </>
  );
};

export default ReviewPlans;
